export default "__VITE_ASSET__2c34b123__"